/**
 * 产品类型内容配置（国际化版本）
 * 使用翻译键而不是硬编码文本
 */

// 获取产品类型内容的国际化版本
export const getProductTypeContentI18n = (productId, productType, t) => {
  // 确定基础产品类型
  let baseType = productId || 'gpt'; // 使用传入的productId，如果没有则默认为gpt
  
  // 确保baseType是有效的产品类型
  const validTypes = ['gpt', 'claude', 'sora', 'grok', 'app'];
  if (!validTypes.includes(baseType)) {
    console.warn(`未知的产品类型: ${baseType}, 使用默认值 gpt`);
    baseType = 'gpt';
  }

  // 使用映射函数转换产品类型
  const mappedProductType = getProductTypeMapping(productType);

  // 构建翻译键的基础路径
  const baseKey = `productDetailPage.productTypeContent.${baseType}.${mappedProductType}`;
  
  try {
    // 返回国际化的产品类型内容
    return {
      description: t(`${baseKey}.description`, ''),
      aboutProduct: t(`${baseKey}.aboutProduct`, { returnObjects: true }) || [],
      afterPurchase: t(`${baseKey}.afterPurchase`, { returnObjects: true }) || [],
      importantNotes: t(`${baseKey}.importantNotes`, { returnObjects: true }) || []
    };
  } catch (error) {
    console.warn(`Failed to get i18n content for ${baseKey}:`, error);
    // 返回空内容作为后备
    return {
      description: '',
      aboutProduct: [],
      afterPurchase: [],
      importantNotes: []
    };
  }
};

// 获取产品类型的标准配置映射
export const getProductTypeMapping = (productType) => {
  const mapping = {
    'official': 'official',
    'official-renewal': 'officialRenewal', 
    'official-shared': 'officialShared',
    'shared': 'shared',
    'monkeyai': 'monkeyai'
  };
  
  return mapping[productType] || productType;
};